export default "__VITE_ASSET__DJo0ghW4__"